import React from 'react';
import styles from './warningPopUp.scss';

const WarningPopUp = (props) => (
    <div
        className={`overlay lite-black ${styles.warning}`}
    >
        <div
            className={`rating-pop-up`}
        >
            <div className="gradient-bar" />
            <div className="pop-up-content">
                {props.title && (
                    <h5 className="text">{props.title}</h5>
                )}
                {props.description && (
                    <p className="text">{props.description}</p>
                )}
                <div className={`text-right pop-up-footer`}>
                    {props.closePopup && (
                        <button
                            type="button"
                            className={`btn btn-default btn-sm text-uppercase`}
                            onClick={props.closePopup}
                            data-testid="warning-popup.cancel-btn"
                        >
                        Cancel
                        </button>
                    )}
                    <button
                        type="button"
                        className={`btn btn-primary btn-sm text-uppercase`}
                        onClick={() => {
                            props.confirmPopup();
                        }}
                        data-testid="warning-popup.confirm-btn"
                    >
                        Continue
                    </button>
                </div>
            </div>
        </div>
    </div>

);

export default WarningPopUp;
